import React from 'react'
import { Link } from 'react-router-dom'
import Blog_1 from '../../../assets/images/blog-news/02.png'

const Blog = () => {
    return (
        <>
            <section id="blog-news-two" className="blog-news-two-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section">
                                <h2 className="section-title cormorant-font">
                                    Latest Blog &amp; News
                                </h2>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="blog-two-block">
                                <div className="blog-news-two-img">
                                    <span className="date">25</span>
                                    <span className="month">Nov</span>
                                    <Link to="/BlogDetails" className="sale" title="">
                                        <img
                                            src={Blog_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </div>
                                <div className="blog-news-two-dtls">
                                    <h6 className="blog-two-sub-title">Primium wooden sofa</h6>
                                    <h4 className="blog-two-title">
                                        <Link to="/BlogDetails" title="">
                                            Updating your Bedroom your in Next Exclusive Furniture{" "}
                                        </Link>
                                    </h4>
                                    <Link to="/BlogDetails" className="btn btn-secondary-second" title="">
                                        Learn More <i className="flaticon-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="blog-two-block">
                                <div className="blog-news-two-img">
                                    <span className="date">25</span>
                                    <span className="month">Nov</span>
                                    <Link to="/BlogDetails" className="sale" title="">
                                        <img
                                            src={Blog_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </div>
                                <div className="blog-news-two-dtls">
                                    <h6 className="blog-two-sub-title">Primium wooden sofa</h6>
                                    <h4 className="blog-two-title">
                                        <Link to="/BlogDetails" title="">
                                            Explore Our Latest Wooden Mart Furniture
                                        </Link>
                                    </h4>
                                    <Link to="/BlogDetails" className="btn btn-secondary-second" title="">
                                        Learn More <i className="flaticon-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="blog-two-block">
                                <div className="blog-news-two-img">
                                    <span className="date">25</span>
                                    <span className="month">Nov</span>
                                    <Link to="/BlogDetails" className="sale" title="">
                                        <img
                                            src={Blog_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </div>
                                <div className="blog-news-two-dtls">
                                    <h6 className="blog-two-sub-title">Primium wooden sofa</h6>
                                    <h4 className="blog-two-title">
                                        <Link to="/BlogDetails" title="">
                                            Glorious Table Lamps in modern modern Room
                                        </Link>
                                    </h4>
                                    <Link to="/BlogDetails" className="btn btn-secondary-second" title="">
                                        Learn More <i className="flaticon-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Blog
